(function ($) {
    $(document).ready(function () {
        if($('.horizontal-tabs').length>0) {
            $('.horizontal-tabs li:first-of-type').addClass("selected");
            $('.horizontal-tabs .tab-wrap .tab-content:first-of-type').addClass("selected");
            $(".horizontal-tabs .mobile-option p").html($('.horizontal-tabs li:first-of-type span').html());
            $('.horizontal-tabs li span').click(function () {
                $(this).parent().addClass("selected").siblings().removeClass("selected");
                $(".horizontal-tabs .mobile-option p").empty().html($(this).html());

                if($(".horizontal-tabs .tab-btn").hasClass("active")){
                    $(".horizontal-tabs .tab-btn").removeClass("active");
                }
            });
            $(".horizontal-tabs .mobile-option").on("click", function () {
                $(this).parent().toggleClass("active");
            });

            // Horizontal tab
            $('.horizontal-tabs ul li').click(function() {   
                var index = $(this).index();
                $(this).addClass('selected').siblings().removeClass('selected');
                $('.horizontal-tabs .tab-wrap .tab-content').eq(index).addClass('selected').siblings().removeClass('selected');
                
              });

        }    
    });
})(jQuery);